/* eslint no-console: 0 */

import { observable, action, makeObservable } from 'mobx'
import { fromServerToClient } from '../../../../lib/utils/collection'
import { listingCaptchaKey } from '../../../../lib/config/recaptcha'
import { noop } from '../../../../lib/utils/common'
import { SRP_SEARCH_INFO, SRP_SEARCH_VALUES_SCOPE } from '../../../../lib/constants/search'
import { rootStoreInstance } from '../../SearchBar/stores'

class ListingsStore {
  @observable collection = []
  @observable totalCount = 0
  @observable isLoading = false
  @observable isCollectionEmpty = false
  @observable breadcrumbs = []
  @observable header = ''

  isAllowedRequest = true

  constructor({ transport, channel, eventBus, sessionStorage, history }) {
    makeObservable(this)

    this.transport = transport
    this.channel = channel
    this.sessionStorage = sessionStorage
    this.history = history

    eventBus.addEventListener('transport.Listing.updateSavedStatus', this.updateListingSaveStatus)
    eventBus.addEventListener('transport.Listing.updateSavedStatusTask', this.updateListingSaveStatus)
    eventBus.addEventListener('fetch-listings', this.fetchCollection)
  }

  @action('[ListingsStore] Set Initial State')
  setInitialState(props) {
    this.collection = props.collection
    this.totalCount = props.totalCount
    this.isLoading = false
    this.isCollectionEmpty = props.collection.length === 0
    this.breadcrumbs = props.breadcrumbs
    this.header = props.header
  }

  @action('[ListingsStore] Set loading for property listings')
  setLoading = value => {
    this.isLoading = value
  }

  @action('[ListingsStore] set total count')
  setTotalCount = value => {
    this.totalCount = value
  }

  @action('[ListingsStore] set breadcrumbs')
  setBreadcrumbs = value => {
    this.breadcrumbs = value
  }

  @action('[ListingsStore] set header')
  setHeader = value => {
    this.header = value
  }

  @action('[ValueStateStore] Set property listings')
  setCollection = data => {
    this.collection = data
  }

  @action('[ListingsStore] Send search listings')
  fetchCollection = async () => {
    try {
      if (this.isLoading) { return }
      this.setLoading(true)

      const {
        listingTypeStore: { current, listingTypes },
        valueStateStore: { valuesForSubmit, currentPage }
      } = rootStoreInstance

      const searchValuesScope = this.sessionStorage.fetchFromSessionStorage(SRP_SEARCH_VALUES_SCOPE)
      const searchInfo = this.sessionStorage.fetchFromSessionStorage(SRP_SEARCH_INFO)
      const query = {
        [searchValuesScope]: valuesForSubmit,
        page: { number: currentPage },
        seed: searchInfo.seed
      }

      const response = await this.transport.Listing.sendListingsSearch(listingTypes[current].searchListingsUrl, query)
      const { data, meta: { totalCount, searchUrl, heading, breadcrumbs } } = fromServerToClient(response)

      this.history.pushState({ url: searchUrl })
      this.setTotalCount(totalCount)
      this.setHeader(heading)
      this.setBreadcrumbs(breadcrumbs)
      this.setCollection(data)
      this.isCollectionEmpty = data.length === 0
      this.setLoading(false)
    } catch (e) {
      noop()
    }
  }

  @action('[ListingsStore] update saved status for Listing')
  updateSaveStatus = listing => {
    const { links: { saveAction: { url, method } } } = listing
    if (this.isAllowedRequest) {
      this.isAllowedRequest = false
      this.transport.Listing.updateSavedStatus({ url, method, captchaKey: listingCaptchaKey(listing) })
        .then(() => (this.isAllowedRequest = true))
        .catch(error => { console.log(error) })
    }
  }

  @action('[ListingsStore] update listing save status')
  updateListingSaveStatus = ({ detail: { data } }) => {
    const listingToUpdate = fromServerToClient(data)

    const updatedCollection = this.collection.map(item =>
      item.id === listingToUpdate.id
        ? {
          ...item,
          links: {
            ...(item.links || listingToUpdate.links),
            saveAction: listingToUpdate.links?.saveAction
          },
          saved: listingToUpdate.saved
        }
        : item
    )
    this.setCollection(updatedCollection)
  }
}

export default ListingsStore
